import { get } from "lodash"

const EMPTY_ARRAY = []

export const getIndices = state => get(state, "global.data.indices.data.indexes", EMPTY_ARRAY)
